<lib-dynamic-listing
  [module]="'journal-voucher'"
  [filters]="filterConfigs"
  [columns]="columnConfigs"
  [data]="tableData"
  [actions]="actionConfigs"
  [isLoading]="isLoading"
  [pageIndex]="pageIndex"
  [rowsPerPage]="rowsPerPage"
  [totalCount]="totalCount"
  [totalPages]="totalPages"
  [exportFilename]="exportFilename"
  (filterEvent)="onFilterEvent($event)"
  (actionClicked)="onActionClicked($event)"
  (pageChanged)="onPageChanged($event)"
  (exportCsv)="exportCsv()"
  (exportXlsx)="exportXlsx()"
  (exportPdf)="exportPdf()"
  [columnPreferenceId]="columnPreferenceId"
  (columnsSelected)="onColumnsSelected($event)"
  (columnPreferenceSaved)="onColumnPreferenceSaved($event)">
</lib-dynamic-listing>

